import React from "react";
import Cookies from "universal-cookie";
import PageTitle from "../../../components/PageTitle/PageTitle";
import getCorsi from "../../../services/getCorsi";
import getInsegnanti from '../../../services/getInsegnanti';
import SearchTable from "../../../widgets/tables/SearchTable";
import getStudentiForBilling from "../../../services/getStudentiForBilling";

export default class Search extends React.Component {

  constructor(props){
    super (props)

    this.searchArray = [];
    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.state = {
      isLoading: true,
      array: [],
      previous: undefined,
      selectPdfDatesVisible: false,
      sendMailVisible: false,
      sendNotificationVisible: false,
      selectDateAulaVisible: false,
    };
  }

  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    this.corsi = await getCorsi(username, token);
    this.insegnanti = await getInsegnanti(username, token);
    this.studenti = await getStudentiForBilling(username, token);

    window.sessionStorage.setItem('', 'search_text');

    this.setState({ isLoading: false });

  }

  componentDidUpdate() {

    setTimeout(() => {

      this.searchArray = [];
      let searchText = window.sessionStorage.getItem('search_text');
      window.sessionStorage.setItem('', 'search_text');

      if (searchText !== null && searchText !== undefined && searchText !== '') {
    
          let corsiMatch = this.corsi.filter((corso) => corso.name.toLowerCase().includes(searchText.toLowerCase()));
          let insegnantiMatch = this.insegnanti.filter((insegnante) => (insegnante.nome.toLowerCase() + ' ' + insegnante.cognome.toLowerCase()).includes(searchText.toLowerCase()) || (insegnante.cognome.toLowerCase() + ' ' + insegnante.nome.toLowerCase()).includes(searchText.toLowerCase()));
          let studentiMatch = this.studenti.filter((studente) => (studente.nome.toLowerCase() + ' ' + studente.cognome.toLowerCase()).includes(searchText.toLowerCase()) || (studente.cognome.toLowerCase() + ' ' + studente.nome.toLowerCase()).includes(searchText.toLowerCase()));
      
          corsiMatch.forEach((corso) => {
            let c = { id: corso.id, descrizione: corso.name, tipo: 'Corso' };
            this.searchArray.push(c);
          });
      
          studentiMatch.forEach((studente) => {
            let s = { id: studente.id, descrizione: studente.nome + ' ' + studente.cognome, tipo: 'Studente' };
            this.searchArray.push(s);
          });
      
          insegnantiMatch.forEach((insegnante) => {
            let i = { id: insegnante.id, descrizione: insegnante.nome + ' ' + insegnante.cognome, tipo: 'Insegnante' };
            this.searchArray.push(i);
          });
        }

        if (searchText !== this.state.previous)
          this.setState({ array: this.searchArray, previous: searchText });

    }, 200);


  }

  render () {

    if (this.state.isLoading) return <div />;
    var headCells = [
      { id: 'descrizione', numeric: false, disablePadding: true, label: 'Descrizione' },
      { id: 'tipo', numeric: true, disablePadding: false, label: 'Tipo' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];

    const cookies = new Cookies();
    this.searchCols = ['nome', 'cognome', 'mail'];

    return (
      <>
        <PageTitle title="Cerca" />

        <SearchTable headCells={headCells} searchCols={this.searchCols} type={'billing'} assenze={true} calendar={false} pdf={true} excel={false} mail={true} phone={true} rows={this.state.array}
      
            onEventClick={(row, tipo) => {
              if (tipo === 'Corso') {
                cookies.set('currentCourse', row, { path: '/' });
                window.location.href = '/#/billing/editCorso';
              } else if (tipo === 'Studente') {
                cookies.set('currentStudent', row, { path: '/' });
                window.location.href = '/#/billing/studenteDetails';
              } else if (tipo === 'Insegnante') {
                cookies.set('currentInsegnante', row, { path: '/' });
                window.location.href = '/#/billing/fattureInsegnante';
              }
            }}

        />

      </>
    );
  }


}
